var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClickCoursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4318ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.672 1.912a1 1 0 0 0-1.932.517l.259.966a1 1 0 1 0 1.931-.517zM2.429 4.74a1 1 0 0 0-.518 1.932l.966.259a1 1 0 1 0 .518-1.932zM11.242 4.172a1 1 0 1 0-1.414-1.415l-.707.708a1 1 0 1 0 1.414 1.414zM4.171 11.243l.707-.707A1 1 0 0 0 3.464 9.12l-.707.707a1 1 0 0 0 1.414 1.415zM7.371 6.072a1 1 0 0 0-1.3 1.3l4 10a1 1 0 0 0 1.823.075l1.38-2.759 3.019 3.02a1 1 0 0 0 1.414-1.415l-3.019-3.019 2.76-1.38a1 1 0 0 0-.077-1.822z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickCoursor);
export default __webpack_public_path__ + "static/media/click-coursor.29687125b85409f6d50333d4e411636b.svg";
export { ForwardRef as ReactComponent };